import { apiFetch } from './apiClient';
import { encryptString, decryptString } from '../utils/crypto';

export interface User {
  username: string;
  role: string;
  phone?: string;
}

function storeToken(token: string) {
  try { localStorage.setItem('xf_auth_token', encryptString(token)); } catch (e) { console.warn('[authService] 保存 token 失败:', e); }
}

export function getStoredToken(): string | null {
  try {
    const enc = localStorage.getItem('xf_auth_token');
    return enc ? decryptString(enc) || null : null;
  } catch (e) { console.warn('[authService] 读取 token 失败:', e); return null; }
}

export async function register(username: string, password: string, phone: string): Promise<{ success: boolean; user?: User; error?: string }> {
  try {
    const response = await apiFetch("/api/auth/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password, phone }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "注册失败");
    if (data.token) storeToken(data.token);
    return data;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
}

export async function login(username: string, password: string): Promise<{ success: boolean; user?: User; error?: string }> {
  try {
    const response = await apiFetch("/api/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "登录失败");
    if (data.token) storeToken(data.token);
    return data;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
}

export async function bootstrap(): Promise<{ success: boolean; user?: User; error?: string; autoLoginDisabled?: boolean }> {
  try {
    const response = await apiFetch("/api/auth/bootstrap");
    if (response.status === 403) {
      // 服务器未启用自动登录（未配置 AUTO_LOGIN_PASSWORD）——直接落到登录页，无需重试
      return { success: false, autoLoginDisabled: true };
    }
    const data = await response.json();
    if (data.token) storeToken(data.token);
    return data;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
}

export async function getMe(): Promise<{ user: User } | null> {
  try {
    const response = await apiFetch("/api/auth/me");
    if (!response.ok) return null;
    return await response.json();
  } catch (err) {
    console.warn('[authService] 获取当前用户失败，已忽略:', err);
    return null;
  }
}

export async function logout(): Promise<void> {
  await apiFetch("/api/auth/logout", { method: "POST" });
}
